import React, { useId } from "react";
import moment from "moment-timezone";
import { localTimeCandidates } from "./time";
import { timeZoneLabel } from "./timeZones";
import "./TimeZoneSelect.css";

export default function DateTimeRangeFields({ values, onChange, timezoneName }) {
  const id = useId();
  return <>
    <p className="schedule-zone-note">Times in {timeZoneLabel(timezoneName)}</p>
    <div className="schedule-datetime-range">
      {[{ date: "localDate", time: "startTime", instant: "startInstant", label: "Start" },
        { date: "endDate", time: "endTime", instant: "endInstant", label: "End" }].map((field) => {
        const date = values[field.date] || values.localDate;
        const candidates = localTimeCandidates(date, values[field.time], timezoneName);
        const selected = candidates.find((candidate) => moment(candidate).isSame(values[field.instant])) || "";
        return <div key={field.label}>
          <label htmlFor={`${id}-${field.date}`}>{field.label} date</label>
          <input id={`${id}-${field.date}`} className="form-control" type="date" required value={date || ""}
            onChange={(event) => {
              if (field.date === "localDate" && (!values.endDate || values.endDate === values.localDate)) onChange("endDate", event.target.value);
              onChange(field.date, event.target.value);
            }} />
          <label htmlFor={`${id}-${field.time}`} className="mt-2">{field.label} time</label>
          <input id={`${id}-${field.time}`} className="form-control" type="time" required value={values[field.time]}
            onChange={(event) => onChange(field.time, event.target.value)} />
          {candidates.length > 1 && <div className="mt-2">
            <label htmlFor={`${id}-${field.instant}`}>{field.label} time occurs twice</label>
            <select id={`${id}-${field.instant}`} className="form-control" required value={selected}
              onChange={(event) => onChange(field.instant, event.target.value)}>
              <option value="">Choose a time</option>
              {candidates.map((candidate, index) => <option key={candidate} value={candidate}>
                {index === 0 ? "First" : "Second"} {moment.tz(candidate, timezoneName).format("h:mm A [· UTC]Z")}
              </option>)}
            </select>
          </div>}
        </div>;
      })}
    </div>
  </>;
}
